import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email: email.trim() || undefined, password });
      localStorage.setItem("sv_admin_token", data.token);
      if (data.user) localStorage.setItem("sv_admin_user", JSON.stringify(data.user));
      navigate("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F1F5F9] flex items-center justify-center px-4">
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-lg p-8 w-full max-w-sm shadow-sm" data-testid="admin-login-form">
        <div className="w-10 h-10 rounded-lg bg-[#970C10] flex items-center justify-center mb-5">
          <Lock className="w-5 h-5 text-white" />
        </div>
        <h1 className="font-heading text-xl font-bold text-slate-900">Sellvago Admin</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">
          Sign in with your team email + password. If it&apos;s your first time and you have the recovery password, use any email + recovery password to auto-provision an owner account.
        </p>
        <div className="relative mb-3">
          <Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@sellvago.com"
            className="w-full border border-slate-200 rounded-lg pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#970C10]/30"
          />
        </div>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#970C10]/30"
        />
        <button
          data-testid="admin-login-btn"
          disabled={loading || !password}
          className="w-full mt-4 bg-[#970C10] hover:bg-[#7A0A0D] text-white font-bold py-2.5 rounded-lg transition-colors duration-200 disabled:opacity-50"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
